// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1tKoh","signatureButtonsRight":"ModalSign_signatureButtonsRight__qYW9V"};